import { AppTableFilter } from '../model';

const serializeFilters = (filtersList: { [key: string]: AppTableFilter[] }): { [key: string]: string[] } => {
    // save only checked values.
    return Object.entries(filtersList).reduce(
        (prev, [key, value]) => ({
            ...prev,
            [key]: value.filter(({ checked }) => checked).map(({ value }) => value)
        }),
        {}
    );
};

export default serializeFilters;
